"use client";
import React from "react";
import { useRouter } from "next/navigation";
import Modal from "../ModalContainer";
import { AudienceModalProps } from "./types";
import { AUDIENCES } from "./audiences";
import AudienceButton from "./AudienceButton";

const AudienceModal: React.FC<AudienceModalProps> = ({
  isOpen,
  onClose,
  selectedCategory,
}) => {
  const router = useRouter();

  const handleNavigate = (audience: string) => {
    onClose();
    router.push(
      `/content?category=${encodeURIComponent(
        selectedCategory
      )}&audience=${encodeURIComponent(audience)}`
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      background="linear-gradient(to right, #b6d4e3, #7698b3)"
    >
      <div className="flex justify-center my-2 sm:my-3 md:my-3">
        <p className="text-xs sm:text-lg md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl">
          {selectedCategory}
        </p>
      </div>
      <div
        className="
          flex flex-col sm:flex-row sm:flex-wrap
          gap-3 px-4 py-4 
          justify-start sm:justify-center items-center 
          max-h-[calc(100vh-150px)] overflow-y-auto
        "
      >
        {AUDIENCES.map((item) => (
          <AudienceButton
            key={item.id}
            item={item}
            onClick={() => handleNavigate(item.id)}
          />
        ))}
      </div>
    </Modal>
  );
};

export default AudienceModal;
